/* tslint:disable */
/* eslint-disable */
/**
 * Ad Asset Generation Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
/**
 * Check if a given object implements the AssetGenerationProgress interface.
 */
export function instanceOfAssetGenerationProgress(value) {
    return true;
}
export function AssetGenerationProgressFromJSON(json) {
    return AssetGenerationProgressFromJSONTyped(json, false);
}
export function AssetGenerationProgressFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'progress': json['progress'] == null ? undefined : json['progress'],
        'total': json['total'] == null ? undefined : json['total'],
        'assetUrl': json['assetUrl'] == null ? undefined : json['assetUrl'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}
export function AssetGenerationProgressToJSON(json) {
    return AssetGenerationProgressToJSONTyped(json, false);
}
export function AssetGenerationProgressToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'jobId': value['jobId'],
        'progress': value['progress'],
        'total': value['total'],
        'assetUrl': value['assetUrl'],
        'error': value['error'],
    };
}
